const GROUP_FIELDS = [
  "StudentId",
  "ExamId",
  "Name",
  "EmailAddress",
  "CourseLanguage",
];

function groupValue(value) {
  if (value == null || value === "") {
    return "";
  }
  return String(value);
}

function utcDay(createdAt) {
  if (typeof createdAt !== "string" || createdAt.length === 0) {
    return null;
  }
  const day = createdAt.split("T")[0];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return null;
  }
  return day;
}

function groupKey(session, day) {
  return [...GROUP_FIELDS.map((field) => groupValue(session?.[field])), day].join(
    "\u0000"
  );
}

export function dedupeAaaFoodHandlerSessions(sessions) {
  const kept = new Map();

  (sessions || []).forEach((session) => {
    const day = utcDay(session?.createdAt);
    if (!day) {
      return;
    }

    const key = groupKey(session, day);
    const existing = kept.get(key);
    if (!existing || session.createdAt > existing.createdAt) {
      kept.set(key, session);
    }
  });

  return Array.from(kept.values());
}
